module.exports = __webpack_public_path__ + "static/media/rectangle-portrait.9e4841f6.svg";